// extracted by mini-css-extract-plugin
export default {"mainContainer":"Footer_mainContainer__O0bzT","linkContainer":"Footer_linkContainer__MABQa"};